import {FilterOperator, Operator} from '../../../app.constants';
import {FieldType} from '../../form-generator/fields/fields.interfaces';

export interface CriterionDescriptor {
  readOnly: boolean;
  hidden: boolean;
  required: boolean;
  zoneID: string;
  zoneGroup?: string;
  transIds: string[];
  transIdsTranslations?: string[];
  dataIndice: number;
  metadatas: any;
  type: FieldType;
}

export interface PopulationCriteria {
  name: string;
  criteria: PopulationCriterion[];
}

export interface PopulationCriterion {
  zoneName: string;
  translatedZoneName?: string;
  dataIndice: number;
  zoneType: FieldType;
  operator: FilterOperator;
  values: any[];
  displayValue?: string;
}

export interface PopulationFormValue {
  contractBeginDate: CriterionForm;
  contractEndDate: CriterionForm;
  contractStatus: CriterionForm;
  criteria?: CriterionForm[];
}

export interface CriterionForm {
  operator: Operator;
  translatedZoneName?: string;
  criterionValue: any;
  criterionZoneId: string;
  criterionDataIndice: number;
  criterionType: FieldType;
}

export interface Entity {
  entityLevel: number;
  id: number;
  name: string;
  parentId: number;
}

export const POPULATION_CRITERIA_COOKIE_NAME = 'gp_population_criteria';

export enum PopulationFormControls {
  CONTRACT_BEGIN_DATE = 'contractBeginDate',
  CONTRACT_END_DATE = 'contractEndDate',
  CONTRACT_STATUS = 'contractStatus',
  CRITERIA = 'criteria',
  OPERATOR = 'operator',
  CRITERION_VALUE = 'criterionValue',
  CRITERION_TYPE = 'criterionType',
  CRITERION_ZONE_ID = 'criterionZoneId',
  CRITERION_DATA_INDICE = 'criterionDataIndice',
}

export enum ContractDefaultZoneName {
  CONTRACT_BEGIN_DATE = '_contractBeginDate',
  CONTRACT_END_DATE = '_contractEndDate',
  CONTRACT_STATUS = '_contractStatus'
}

export enum PopulationCriteriaName {
  MY_CUSTOM_POPULATION = 'My custom population'
}

export enum ContractStatusValue {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  FUTURE = 'FUTURE'
}

export enum ContractStatusDisplay {
  ACTIVE = 'EMPLOYEE_MANAGE.employee_status_active',
  INACTIVE = 'EMPLOYEE_MANAGE.employee_status_inactive',
  FUTURE = 'EMPLOYEE_MANAGE.employee_status_future'
}

export interface ContractStatus {
  value: ContractStatusValue;
  display: ContractStatusDisplay;
}


